import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { Enterprise } from '@/store/types/public/Enterprise';
import PubHttp from '@/PubHttp';
import { PageMeta } from '@/store/types/pagination';
import { NAMESPACE as ENTERPRISE_NAMESPACE } from '@/store/models/pub/enterprises';
import { GET_ITEM, RootState } from '@/store';

export type Group = {
  id: string
  title: string
  parent_id: string
  parent: Group
  children: Group[]
}

export const NAMESPACE = 'pub/products/groups';

export interface GroupsState extends RootState {
  items: Group[]
}

export const state: GroupsState = {
  status: null,
  items: [],
  meta: undefined
};

export const getters: GetterTree<GroupsState, any> = {
  items: (state) => state.items,
  status: (state):boolean|null => state.status,
  loading: (state):boolean => state.status === null,
  meta: (state) => state.meta
};

export const actions: ActionTree<any, any> = {
  request: ({ commit, rootGetters }:any) => {
    let enterprise: Enterprise = rootGetters[ENTERPRISE_NAMESPACE + '/' + GET_ITEM];
    commit('request');
    (new PubHttp()).request({ url: `enterprises/${enterprise.id}/product-groups` })
      .then((resp:any) => {
        commit('success', resp.data);
      })
      .catch(() => {
        commit('error');
      });
  }
};

export const mutations: MutationTree<GroupsState> = {
  request: (state) => {
    state.status = null;
  },
  success: (state, resp:{data: Group[], meta?: PageMeta}) => {
    state.status = true;
    state.items = resp.data;
    state.meta = resp.meta;
  },
  error: (state) => {
    state.status = false;
  }
};

export const groups: Module<GroupsState, any> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
